import React from "react";
import Moment from "react-moment";
import { Box, Divider, Grid, Typography, Link } from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import { ISchedulingItem } from "src/common/typings/scheduling";
import { setDateTimeToLocal } from "src/common/utils/app.util";
import { moneyformatter } from "src/common/utils/helpers";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    marginLabelHeading: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      //lineHeight: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      color: "#000",
      lineHeight: "28px",
    },
    marginLabelText: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      //lineHeight: "20px",
      // fontSize: "inherit",
    },
  })
);

type Props = {
  stickyInfo: ISchedulingItem;
};

export function Sticky({ stickyInfo }: Props): React.ReactElement {
  const classes = useStyles();
  const addressFormate = () => {
    const addfor: any[] = [];
    if (stickyInfo?.city) {
      addfor.push(stickyInfo?.city);
    }
    if (stickyInfo?.state) {
      if (stickyInfo?.city) {
        addfor.push(` ${stickyInfo?.state}`);
      } else {
        addfor.push(stickyInfo?.state);
      }
    }
    if (stickyInfo?.zipCode) {
      if (stickyInfo?.state || stickyInfo?.city) {
        addfor.push(` ${stickyInfo?.zipCode}`);
      } else {
        addfor.push(stickyInfo?.zipCode);
      }
    }
    if (addfor.length) {
      return addfor.toString();
    } else {
      return "";
    }
  };
  return (
    <>
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Box ml={0}>
            <Grid item xs={12} md={12}>
              <Box mt={2}>
                <Typography className={classes.heading}>Scheduling Details</Typography>
              </Box>
            </Grid>
            <Divider />
            <Box p={2} mb={3}>
              <Grid container direction="row">
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Original NTE:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {moneyformatter(stickyInfo?.nte)}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Status:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.status || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Client Code:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.cleintCode || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Store Number:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.loc || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>
                          Service Begin:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.beginService && (
                            <Moment
                              local={true}
                              format="MM/DD/YYYY hh:mm A"
                              date={stickyInfo?.beginService || ""}
                            />
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Service End:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.serviceEnd && (
                            <Moment
                              local={true}
                              format="MM/DD/YYYY hh:mm A"
                              date={stickyInfo?.serviceEnd || ""}
                            />
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={6}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Phone #:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box color="text.main">
                        <Link
                          component="button"
                          variant="body1"
                          className={classes.marginLabelText}
                          onClick={(e: any) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(`tel:${stickyInfo?.phone || ""}`, "_self");
                            return false;
                          }}
                        >
                          {stickyInfo?.phone || ""}
                        </Link>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={3}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Address:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {stickyInfo?.address || ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container direction="row">
                    <Grid item xs={12} md={3}>
                      <Box color="text.secondary">
                        <Typography className={classes.marginLabelHeading}>Address:</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <Box color="text.main">
                        <Typography className={classes.marginLabelText}>
                          {addressFormate()}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
